module.exports = __webpack_public_path__ + "static/media/dc-behind.1afa20c7.svg";